export const REGISTER_FOR_ACTIVITY_PACK_REQUEST = 'REGISTER_FOR_ACTIVITY_PACK_REQUEST'
export const REGISTER_FOR_ACTIVITY_PACK_SUCCESS = 'REGISTER_FOR_ACTIVITY_PACK_SUCCESS'
export const REGISTER_FOR_ACTIVITY_PACK_ERROR = 'REGISTER_FOR_ACTIVITY_PACK_ERROR'
